import React, { useEffect, useState } from "react";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Typography } from "antd";
import { AuthInfo } from "stores/slices/auth";
import { doGetMessageEvent } from "stores/slices/message";
import { getUserDetail } from "stores/slices/user";

import business from "../../../assets/images/business-webp.webp";
import logo from "../../../assets/images/icon-black-transparent-webp.webp";

import ChatMessageBody from "./chatMessageBody";
import ChatMessageFooter from "./chatMessageFooter";
import ChatMessageHeader from "./chatMessageHeader";

import "../../../assets/styles/chatMessageStyle.scss";

const ChatMessage = props => {
  const {
    below768,
    isOpenLayoutRight,
    setIsOpenLayoutRight,
    isLoadingConversation,
    conversationSelected,
  } = props;
  const authInfo = useSelector(AuthInfo);

  const urlParam = useParams();
  const dispatch = useDispatch();

  const inputUploadFileRef = useRef(null);
  const inputUploadImgRef = useRef(null);
  const userInfo = useSelector(getUserDetail);
  const [params, setParams] = useState(null);
  // const [serviceNumber, setServiceNumber] = useState("");
  const [serviceSelected, setServiceSelected] = useState(null);

  useEffect(() => {
    if (authInfo && authInfo.workspaceId && urlParam && urlParam.id) {
      dispatch(
        doGetMessageEvent({
          workspaceId: authInfo.workspaceId,
          conversationId: urlParam.id,
        })
      );
    }
  }, [urlParam.id]);

  return (
    <>
      <div className="chatMessageContainer">
        <>
          {urlParam.id === "messages" && (
            <div
              style={{
                padding: "5vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div style={{ marginRight: 12 }}>
                <img
                  src={logo}
                  width={107}
                  height={103}
                  type="image/webp"
                  alt="logo"
                  style={{ width: "8vw", height: "auto" }}
                />
              </div>
              <Typography.Title
                level={1}
                style={{
                  margin: 0,
                  fontSize: "2.5vw",
                  fontWeight: "700",
                  width: "auto",
                  maxWidth: "600px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Hi{" "}
                {userInfo?.firstName || userInfo?.lastName
                  ? userInfo?.firstName + " " + userInfo?.lastName
                  : userInfo?.email}
              </Typography.Title>
              <Typography.Title
                level={5}
                style={{ marginTop: 0, fontSize: "1.2vw" }}
              >
                Please select your contacts to start conversation.
              </Typography.Title>
            </div>
          )}
          {urlParam.id === "messages" && (
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <img
                width={459}
                height={465}
                src={business}
                alt="background"
                style={{
                  width: "50vh",
                  opacity: "0.8",
                }}
                type="image/webp"
              />
              {/* <Image
                width={459}
                height={465}
                srcSet={business}
                type="image/webp"
                preview={false}
                alt="background"
                style={{
                  width: "50vh",
                  opacity: "0.8",
                }}
                loading="lazy"
              /> */}
            </div>
          )}
          {urlParam.id !== "messages" &&
            !isLoadingConversation &&
            conversationSelected &&
            conversationSelected.id && (
              <>
                <ChatMessageHeader
                  below768={below768}
                  isOpenLayoutRight={isOpenLayoutRight}
                  setIsOpenLayoutRight={setIsOpenLayoutRight}
                  inputUploadFileRef={inputUploadFileRef}
                  params={params}
                  setParams={setParams}
                  // serviceNumber={serviceNumber}
                  serviceSelected={serviceSelected}
                />
                <ChatMessageBody
                  params={params}
                  setParams={setParams}
                  setServiceSelected={setServiceSelected}
                  // setServiceNumber={setServiceNumber}
                />
                <ChatMessageFooter
                  inputUploadFileRef={inputUploadFileRef}
                  inputUploadImgRef={inputUploadImgRef}
                  serviceSelected={serviceSelected}
                />
              </>
            )}
        </>
      </div>
    </>
  );
};

export default ChatMessage;
